import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {TicketSetReadyToUseResultVo} from '../../common/shared/api/nicolas/vo/TicketSetReadyToUseResultVo.interface';

/**
 * 세트 이용권 준비 상태 조회
 *
 * Origin: pageNicolasApi.getTicketSetReadyToUse
 * API: GET /api/v1/ticket/set_ready_to_use
 */
export async function getTicketSetReadyToUse(
  {
    setId,
    seriesId,
  }: {
    setId: number;
    seriesId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: TicketSetReadyToUseResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/set_ready_to_use',
    {
      method: 'GET',
      params: {
        set_id: setId,
        series_id: seriesId,
      },
    },
    options
  );

  return response.data;
}
